import React, { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import Tr from './Tr';

import './Single.css'
import ImageModal from '../common/Modal/ImageModal'
import NewCardSettingModal from './Modal/NewCardSettingModal'

import { useTranslation } from "react-i18next";

const Single = ({force}) => {
  const { t } = useTranslation();
  // const {id} = useParams();
  const {shop} = useParams();

  const [cardSetting, changeCardSetting] = useState(true);

  const showCardSettingHandler = () => {
    changeCardSetting(true);
  }


  const [totalRefundPoint, setTotalRefundPoint] = useState(0);
  const [totalNumber, setTotalNumber] = useState(0);

  const [packageTypeList, setPackageTypeList] = useState([]);
  const [packageInfo, setPackageInfo] = useState({
    packageId: '',
    packageType: '',
    packageName: '',
    packagePrice: '',
    packageNumber: '',
    packageStartAt: '',
    packageEndAt: '',
    packageImage: '',
  });

  const [cardNumber, setCardNumber] = useState(0);
  const [cardList, setCardList] = useState([]);

  const [loading, setLoading] = useState(t('common.loading'));

  const [singleCardTags, setSingleCardTags] = useState([]);

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/single-package`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Accept': 'application/json'
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      // console.log(data)
      if(!data.errors) {
        
        if (data.package) {
          setPackageInfo({
            packageId: data.package.id,
            packageType: 1,
            // packageName: data.package.name,
            // packagePrice: data.package.price,
            // packageNumber: data.package.number,
            // packageStartAt: data.package.start_at.split(' ')[0],
            // packageEndAt: data.package.end_at.split(' ')[0],
            // packageImage: process.env.REACT_APP_ASSET_URL + data.package.image_url,
            // packageStatus: data.package.status,
          });

          

          fetch(`${process.env.REACT_APP_API_URL}/api/single-package-cards/${data.package.id}`, {
            headers: {
              'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
              'Bearer': decodeURIComponent(token),
              'Accept': 'application/json'
            },
            credentials: 'include',
          })
          .then(response => response.json())
          .then(data => {
            if(!data.errors) {
              // if (data.package_cards) {

                setCardNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
                setCardList(data.package_cards.map((card) => {
                  return {
                    card_id: card.card_id,
                    url: process.env.REACT_APP_ASSET_URL + card.image_url,
                    name: card.name,
                    rank: card.rank,
                    number: card.number,
                    description: card.description,
                    stock: card.number,
                    rewardPoint: card.point,
                    psa: card.psa,
                    isPsaEnabled: card.is_psa_enabled,
                    id: card.id,
                    singleTypeId: card.single_type,
                    singleTypeName: card.package_type_name,
                    tagId: card.tag_id,
                    tagName: card.tag_name,
                  }
                }))
                setTotalRefundPoint(data.package_cards.map((card) => card.rank == 9 ? card.point : card.number * card.point).reduce((a, b) => a + b, 0));
                setTotalNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
              
              // }

            }

            setLoading(t('single_card.error'))
          })
            
        } else {
          
        }
        
      } else {
        alert(t('common.error'))
      }
    })
    .catch(error => {
      alert(t('common.error'))
    });

    fetch(`${process.env.REACT_APP_API_URL}/api/package-master`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': xsrfToken,
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      setPackageTypeList(data.package_type_masters);
    })
    .catch(error => {
      alert(t('common.error'))
    });

    fetch(`${process.env.REACT_APP_API_URL}/api/single_card_tags`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': xsrfToken,
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      setSingleCardTags(data.single_card_tags);
    })
    .catch(error => {
      alert(t('common.error'))
    });

  }, []);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalImageIsOpen, setModalImageIsOpen] = useState([false, '']);

  const openImageModal = (e) => {
    setModalImageIsOpen([true, e.target.src]);
  }

  const closeImageModal = () => {
    setModalImageIsOpen([false, '']);
  }


  const openModal = () => {
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false);
  }

  const CreateCardList = () => {
    if (cardList.length == 0) {
      return (
        <tr>
          <td colSpan="8">{loading}</td>
        </tr>
      );
    }
    return cardList.map((card) => {
      return <Tr single={card} openModal={openModal} openImageModal={openImageModal} cardNumber={cardNumber} setCurrentCard={setCurrentCard} cardList={cardList}  setCardList={setCardList} key={'card'+card.id} />

    })
  }

  const [currentCard, setCurrentCard] = useState({
    card_id: '',
    url: '',
    name: '',
    rank: 1,
    number: 1,
    rewardPoint: 0,
    id: '',
    option: "1",
    image: '',
    psa: 0,
    isPsaEnabled: 2,
    singleTypeId: 1,
    singleTypeName: 'Pokemon',
    tagId: '',
    tagName: '',
    packageType: '',
    description: '',
});
  
  const [selectedOption, setSelectedOption] = useState('1');
  

  const addCardHandler = () => {
    setCurrentCard({
      card_id: '',
      url: '',
      name: '',
      rank: 1,
      number: 1,
      rewardPoint: 0,
      id: '',
      option: "1",
      image: '',
      psa: 0,
      isPsaEnabled: 2,
      singleTypeId: 1,
      singleTypeName: 'Pokemon',
      tagId: '',
      tagName: '',
      packageType: '3',
      description: '',
    });
    openModal();
  }


  const zipDownload = () => {
    // '/package-cards/zipdown/{id}'

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/single-package-cards/zipdown/${packageInfo.packageId}`, {
      method: 'POST',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
      //responseType: 'blob',
    })
//   .then(response => console.log(response.data))
    .then(response => response.blob())
    .then(blob => {

      const uri = URL.createObjectURL(blob)
      const link = document.createElement('a');
      link.href = uri;
       link.setAttribute('download', 'single-cards.zip');
      //link.setAttribute('download', 'single.jpg');
      document.body.appendChild(link);
      link.click();

    })
    .catch(error => {
      console.error(error);
    });

  }


  const csvCardHandler = () => {

    console.log(`csvCardHandler called`)

    if (window.confirm(t('single_card.confirm'))) {
      document.getElementById('zip').click();
    }
  }

  // const templateHandler = () => {
  //   window.open(process.env.REACT_APP_ASSET_URL + '/static/template/template.csv');
  // }

  const zipCardHandler = () => {
    setZipUpButton(t('single_card.uploading'));

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    let formData = new FormData();
    formData.append('file', document.getElementById('zip').files[0]);

    fetch(`${process.env.REACT_APP_API_URL}/api/single-package-cards/zip/${packageInfo.packageId}`, {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setCardNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
        setTotalRefundPoint(data.package_cards.map((card) => card.rank == 9 ? card.point : card.number * card.point).reduce((a, b) => a + b, 0));
        setCardList(data.package_cards.map((card) => {
          return {
            url: process.env.REACT_APP_ASSET_URL + card.image_url,
            name: card.name,
            rank: card.rank,
            number: card.number,
            description: card.description,
            stock: card.stock,
            rewardPoint: card.point,
            id: card.id,
            card_id: card.card_id,
            psa: card.psa,
            isPsaEnabled: card.is_psa_enabled == 1 ? "1" : "2",
            singleTypeId: card.single_type,
            singleTypeName: card.package_type_name,
            tagId: card.tag_id,
            tagName: card.tag_name,
          }
        }))
      } else {
        // ファイルのクリア
        document.getElementById('zip').value = '';
        alert(data.errors);
      }
      setZipUpButton(t('single_card.zip_upload'));
    })
    .catch((error) => {
      document.getElementById('zip').value = '';
      console.error('Error:', error);
      alert(t('common.error'));
      setZipUpButton(t('single_card.zip_upload'));
    });

  }

  const [zipUpButton, setZipUpButton] = useState(t('single_card.zip_upload'));

  useEffect(() => {
    setZipUpButton(t('single_card.zip_upload'));
  }, [t('single_card.zip_upload')]);

  return (
    <>
      <Header />
      <SideMenu />
      <NewCardSettingModal 
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        currentCard={currentCard}
        setCurrentCard={setCurrentCard}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        packageInfo={packageInfo}
        cardList={cardList}
        setCardList={setCardList}
        cardNumber={cardNumber}
        setCardNumber={setCardNumber}
        setTotalRefundPoint={setTotalRefundPoint}
        packageTypeList={packageTypeList}
        singleCardTags={singleCardTags}
      />
        <div className="oripa">
          <div className="oripa-content">
            <div className="oripa-title">{t('single_card.card_management')}</div>
            <div className='clearfix'></div>
            <dl className="oripa-info-confirm oripa-info-confirm-half">
              <dt className="oripa-info-confirm-title clear-left">{t('single_card.number_setting')}</dt>
              <dd className="oripa-info-confirm-text"> {totalNumber.toLocaleString()}{t('single_card.card')}</dd>
              <dt className="oripa-info-confirm-title clear-left">{t('single_card.total_reward_points')}</dt>
              <dd className="oripa-info-confirm-text">{totalRefundPoint.toLocaleString()}pt</dd>
            </dl>
            <div className='clearfix'></div>
            <div className="oripa-info-sub-title">{t('single_card.card_settings')} </div>
              <div className="oripa-info-confirm-button">
                <button className="oripa-info-confirm-button-new" onClick={addCardHandler}>{t('single_card.add_new_card')}</button>
                <button className="oripa-info-confirm-button-csv" onClick={csvCardHandler}>{zipUpButton}</button>
                <button className="oripa-info-confirm-button-csv" onClick={zipDownload}>{t('single_card.zip_download')}</button>
                {/* <button className="oripa-info-confirm-button-csv" onClick={templateHandler}>.csvテンプレート</button> */}
              </div>
              <input type="file" id="zip" accept=".zip" style={{display: 'none'}} onChange={zipCardHandler}/>

             
              <div className='line2'></div>
              <div className="oripa-content-table">
                <table className="oripa-content-table">
                  <thead>
                    <tr>
                      <th>{t('single_card.card_image')}</th>
                      <th>{t('single_card.name')}</th>
                      <th>{t('single_card.kinds')}</th>
                      <th>{t('single_card.stock')}</th>
                      <th>{t('single_card.reward_points')}</th>
                      <th>PSA</th>
                      <th>{t('single_card.tag')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <CreateCardList />
                  </tbody>
                </table>
              </div>
            </div>
        </div>
        {modalImageIsOpen[0] && 
        <ImageModal
          modalIsOpen={modalImageIsOpen}
          closeModal={closeImageModal}
          link={modalImageIsOpen[1]}
          customClass='oripa-info-card-image-modal'
        />
        }

    </>
  )
}

export default Single